import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "config/theme/baseTheme";
import { f } from "msw/lib/glossary-de6278a9";
import { fontWeight } from "styled-system";
import { marginBottom } from "styled-system";
import { margin } from "styled-system";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    otpRoot:{
        "& .heading": {
            fontSize: "16px",
            color: COLORS.BLACK,
            fontWeight: 600,
            marginBottom: "12px",
        }, 
        "& .subHeading": {
            fontSize: "14px",
            color: COLORS.BLACK,
            marginBottom: "14px",
            fontWeight: 400
        }, 
        "& .subtitle1": {
            fontSize: "12px",
            color: COLORS.BLACK,
            fontWeight: 600,
            marginBottom: "12px",
        },
    },
    otpInputs: {
        display: "flex",
        gap: "10px",
        margin: "12px 0",
        "& input": {
            width: "50px",
            height: "50px",
            textAlign: "center",
            fontSize: "24px",
            border: `1px solid ${COLORS.DOVE_GRAY_LIGHT}`,
            borderRadius: "5px",
            "&:focus": {
                borderColor: COLORS.PRIMARY_MAIN,
            },
        },
    },
    continueBtn:{
        width: "100%",
        color: COLORS.WHITE,
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
        margin: "12px 0",
        background: COLORS.PRIMARY_MAIN,
        '&:hover': {
            backgroundColor: COLORS.PRIMARY_MAIN, // Prevent background color change
            textDecoration: 'none', // Prevent text decoration
          },
        '&:disabled': {
            backgroundColor: theme.palette.grey[400],
            color: theme.palette.grey[600],
            cursor: 'not-allowed',
          },
    }
  })
);